import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import TrackRecord from './components/TrackRecord';
import InfoSection from './components/InfoSection';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="bg-slate-950 min-h-screen text-slate-300 selection:bg-sage-400 selection:text-slate-950 font-light">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <TrackRecord />
        <InfoSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;